/* KIVI flipbook. Gerenderd uit de definitieve drukbestanden van 20 augustus 2026.
   Onderschriften volgen de taal van de pagina. */
(function(){
  var B='https://cdn.shopify.com/s/files/1/0959/1059/2778/files/';
  var P={
    fv:B+'cover-verdigris-voor.png?v=1787233417',
    fl:B+'cover-lava-voor.png?v=1787233417',
    bv:B+'cover-verdigris-achter.png?v=1787233417',
    bl:B+'cover-lava-achter.png?v=1787233417',
    ins:B+'binnenzijde-omslag.png?v=1787233418',
    lin:B+'binnenwerk-gelijnd.png?v=1787233416'
  };

  var EN = (document.documentElement.lang || 'nl').toLowerCase().indexOf('nl') !== 0;
  var T = EN
    ? { voor:'Front', ins:'Inside cover', lin:'Lined page', achter:'Back' }
    : { voor:'Voorkant', ins:'Binnenzijde omslag', lin:"Gelijnde pagina's", achter:'Achterkant' };

  function page(src,w,alt,spread){
    return '<div class="pnl'+(spread?' pnl--spread':'')+'" style="width:'+w+'px">'+
      '<img src="'+src+'" alt="'+alt+'" style="width:100%;height:100%;display:block;object-fit:cover;border-radius:inherit">'+
    '</div>';
  }

  function set(c){
    var front = c==='V' ? P.fv : P.fl;
    var back  = c==='V' ? P.bv : P.bl;
    var name  = c==='V' ? 'Verdigris' : 'Lava';
    return [
      [T.voor,   page(front,300,'KIVI B6 '+T.voor+' '+name)],
      [T.ins,    page(P.ins,600,'KIVI B6 '+T.ins,true)],
      [T.lin,    page(P.lin,300,'KIVI B6 '+T.lin)],
      [T.achter, page(back,300,'KIVI B6 '+T.achter+' '+name)]
    ];
  }

  window.KIVIFLIP={V:set('V'),L:set('L')};
})();
